import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { RadioBtnComponent } from './radio-btn.component';

@NgModule({
    declarations: [
        RadioBtnComponent
    ],
    imports: [
        CommonModule,
        RouterModule
    ],
    exports: [
        RadioBtnComponent
    ]
})
export class RadioButtonModule { }